import {
  Heading,
  Box,
  Flex,
  AspectRatio,
  Button,
  Stack,
  useMediaQuery
} from '@chakra-ui/react';
import {
  GridPatternDark,
  LayoutContainer,
  RoundedCorner
} from '@components/common';
import { useEffect, useState } from 'react';
import { analytics } from 'pages';
import { Hero, Investors } from '@components/company';
import Link from 'next/link';
import { NextPage } from 'next';
import { singlePageProps } from '@lib';

const Company: NextPage = () => {
  useEffect(() => {
    analytics.track(`Marketing_About_ Viewed`, {
      surface: 'Marketing',
      location: 'About'
    });
  }, []);

  const [isShorterThan920] = useMediaQuery('(max-height: 920px)');

  const [isSmallerThan770] = useMediaQuery('(max-width: 770px)');

  return (
    <LayoutContainer
      verticalPadding="sm"
      pos="relative"
      bgGradient="linear(to-br, #E8E4FF 0%, #F6F9FC 40%, #E5F7FF 100% )"
      pt={{ base: '180px', md: '0px' }}
    >
      <AspectRatio
        ratio={1400 / 1190}
        w="1400px"
        pos="absolute"
        zIndex={0}
        top="200px"
        left="10%"
        pointerEvents="none"
        draggable={false}
        userSelect="none"
      >
        <GridPatternDark />
      </AspectRatio>

      <Stack
        gap={'120px'}
        mt={isShorterThan920 && isSmallerThan770 ? '180px' : 0}
      >
        <Hero />

        <Investors />

        <Flex
          flexDir={{ base: 'column', sm: 'row' }}
          alignItems={'center'}
          justifyContent="space-evenly"
          pos="relative"
          gap={{ base: 4, sm: 0 }}
          pb="120px"
        >
          <Heading
            as="h1"
            w={{ sm: '400px' }}
            textAlign={{ base: 'center', sm: 'left' }}
          >
            Come build with the best.
          </Heading>
          <Box w="25%"></Box>
          <Link href="https://apply.workable.com/clerk-dev/">
            <Button px="24px">View Open Positions</Button>
          </Link>
        </Flex>
      </Stack>

      <Box display={{ base: 'none', md: 'inline-flex' }}>
        <RoundedCorner
          canvasHeight={160}
          bg={'#F6F9FC'}
          yPosition="bottom"
          xPosition="left"
        />
        <RoundedCorner
          canvasHeight={160}
          bg={'#E4F6FF'}
          yPosition="bottom"
          xPosition="right"
        />
      </Box>
    </LayoutContainer>
  );
};

export default Company;

export async function getStaticProps({ preview = false }) {
  return singlePageProps({ preview, slug: '/company' });
}
